import { getActiveFieldId, getActiveUserId } from 'current/selectors';
import { getAllFields } from 'fields/selectors';
import { extractFieldIdentifier } from 'fields/utils';
import { resourceType } from 'constants/loading';
import { findResource } from 'loading/finders';

import { getTrialPlacementOptions } from './selectors';
import { processTrialPlacementOptions } from './processors';
import { fetchTrialPlacementsByFieldId } from './loaders';
import { queryParam } from 'util/queryString';

export const findTrialPlacements = ({ dispatch, getState, forceReload=false, forceWait=false, onError }) => {
  
  const state = getState();
  const userId = getActiveUserId(state);
  const fields = getAllFields(state);
  const fieldId = getActiveFieldId(state);
  const fieldUuid = extractFieldIdentifier({ fields, id: fieldId }).uuid;
  const year = queryParam('year');
  const cropName = decodeURI(queryParam('cropName'));
  const seasonName = queryParam('seasonName');
  
  const resourceSpec = {
    type: resourceType.EXPERIMENTS,
    selector: () => getTrialPlacementOptions(getState()),
    fetcher: () => fetchTrialPlacementsByFieldId({ userId, fieldId: fieldUuid, year, cropName, seasonName }),
    processor: ( response ) => { 
      processTrialPlacementOptions(
        { dispatch, getState, trialPlacements: response && response.data ? response.data.trialPlacements : {}}
      );}
  };
  return findResource({ dispatch, getState, forceReload, forceWait, onError, ...resourceSpec });
};
